jQuery(function ($) {
	$(function () {
		const contentSections = Array.from(document.getElementsByClassName('button-section-content'));

		if (!contentSections[0]) {
			return;
		}

		const contentHeaders = Array.from(document.getElementsByClassName('button-section-header'));
		const headerContainer = document.createElement('div');
		const buttonContainer = document.createElement('div');
		const contentContainer = document.createElement('div');

		headerContainer.classList.add('button-section-header-container');
		buttonContainer.classList.add('button-section-button-container');
		contentContainer.classList.add('button-section-content-container');

		const parentContainer = contentSections[0].parentNode;

		contentHeaders.forEach((section, i) => {
			if (i !== 0) {
				section.classList.add('button-section-hidden');
			}
			headerContainer.appendChild(section);
		});

		let activeIndex = 0;
		const selectedTab = document.getElementById("selected-tab");
		let selectedTabString = "";
		if (selectedTab) {
			selectedTabString = sanitizedTitle(selectedTab.value);
		}

		contentSections.forEach((section, i) => {
			if (sanitizedTitle(section.dataset.sectionTitle) == selectedTabString) {
				activeIndex = i;
			}

			section.classList.add('button-section-hidden');
			contentContainer.appendChild(section);

			const button = document.createElement('button');
			const title = section.dataset.sectionTitle;
			button.innerText = title;
			button.classList.add('btn');
			button.classList.add('button-section-button');
			button.id = sanitizedTitle(title) + "-button";
			buttonContainer.appendChild(button);

			button.addEventListener('click', () => {
				updateButtonSections(title);
			});
		});

		// Set correct contentSection to be active
		const section = contentSections[activeIndex];		
		section.classList.remove('button-section-hidden');
		const button = buttonContainer.querySelector("#" + sanitizedTitle(section.dataset.sectionTitle) + "-button");
		if (button != null) {
			button.classList.add('button-section-button-active');
		} else {
			console.log("Button cannot be found in DOM. Make sure that sanitized title is correct.");
		}

		if (contentHeaders[0]) {
			contentHeaders[0].classList.remove('button-section-hidden');
		}

		parentContainer.appendChild(headerContainer);
		parentContainer.appendChild(buttonContainer);
		parentContainer.appendChild(contentContainer);
	});
});

function updateButtonSections(title) {
	const allSections = Array.from(document.querySelectorAll('[data-section-title]'));
	const allButtons = Array.from(document.getElementsByClassName('button-section-button'));
	const selectedButton = document.getElementById(sanitizedTitle(title) + "-button");

	allButtons.forEach(button => { button.classList.remove('button-section-button-active') });
	selectedButton.classList.add('button-section-button-active');

	allSections.forEach(element => {
		if (element.dataset.sectionTitle == title) {
			element.classList.remove('button-section-hidden');
		} else {
			element.classList.add('button-section-hidden');
		}
	});
	// This is needed to update the parallax mirror DOM element.
	window.dispatchEvent(new Event('resize'));
}

function sanitizedTitle(title) {
	return title.replace(/ /g, '').replace(/[^A-Za-z0-9 ]/g, '').trim().toLowerCase();
}